import React from 'react'
import {Box,Typography,AppBar,Toolbar,IconButton,Paper} from "@mui/material"
import Carousel from 'react-material-ui-carousel'

const CarouselItem=(props)=>{
    return(
        <Box component="img" src={props.imgSrc} sx={{width:{xs:"90vw",md:"40vw"},borderRadius:"50px"}}/>
    )
}

export default function Home() {
    const carouselItems=[
        {
            title:"Helo",
            imgSrc:"https://i.postimg.cc/SKDPTryf/image.png",
            key:1
        },
        {
            title:"Helo",
            imgSrc:"https://i.postimg.cc/rm4PVL1Q/image.png",
            key:3
        },
        {
            title:"Helo",
            imgSrc:"https://i.postimg.cc/5N5W58Fn/image.png",
            key:2
        },
        
        {
            title:"Helo",
            imgSrc:"https://i.postimg.cc/ZKbVgNMf/image.png",
            key:4
        },
    
        // {
        //     title:"Helo",
        //     imgSrc:"https://i.postimg.cc/Y2QfKwZw/front-view-pile-towels-with-iron.jpg",
        //     key:4
        // },
        // {
        //     title:"Helo",
        //     imgSrc:"https://i.postimg.cc/65g9dD6y/young-african-american-man-doing-laundry.jpg",
        //     key:5
        // }
       
    ]
    return (
        <Box > 
            <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",width:"100vw", minHeight:"100vh",backgroundColor:"#f4f4f4",marginTop:{md:"7vh"}}}>
                <Typography variant="h3" color="primary">
                Ecossories
                </Typography>
                <Typography sx={{textAlign:"center"}}>
                    Welcome to a sustainable end to end fashion accessory B2B brand
                </Typography>
                <Box sx={{minHeight:"80vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                   {/* <Carousel>
                        {carouselItems.map((a)=><CarouselItem key={a.key} imgSrc={a.imgSrc}/>)}
                 </Carousel>*/}
                 <Box component="img" src={"https://i.postimg.cc/SKDPTryf/image.png"} sx={{width:{xs:"90vw",md:"40vw"},borderRadius:"50px"}}/>

                </Box>
            </Box>

        </Box>
    )
}
